import { parsePurify } from '../../utils/parsePurify';
import './blogCard.css';

export default function BlogCard({ blogData }) {
    const openBlog = () => {
        window.open(`/blog/details/${blogData._id}`, '_blank');
    };
    return (
        <div className='blogCard' role='button' onClick={openBlog}>
            <img alt='trvto_blog' src={blogData?.image} className='blogImage' loading='lazy' decoding='async' />
            <div className='blogCardTextDiv'>
                <h3 className='blogCardName'>{blogData?.name}</h3>
                <p className='blogCardDis'>{parsePurify(blogData?.shortDescription)}</p>
            </div>
        </div>
    );
}
